const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 443,
    height: 480,
    viewBox: "0 0 443 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "OKO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M194.5,197.1a27.14,27.14,0,0,0-4.3-27.3c-6.3-7.4-15.5-9-22.3-4s-9.6,15.4-6.7,25.3,10.7,16.7,19,16.5",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: "2.036400079727173px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.1,182.2c-.4,8.8,4.8,17,12.1,19.2s14.4-2.5,16.5-10.8-1.3-17.7-8-21.8-14.7-1.9-18.5,5.4",
    style: {
      fill: "#1e74fd",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: "2.036400079727173px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.9,170.6c-5.4-10.7-16.8-17.2-27.7-15.9s-18.4,10.2-18.3,21.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: "1.6970000267028809px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.2,196.5a31,31,0,0,0-23.2,5.8c-6.5,5-10.3,12.2-10.3,19.7",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: "1.6970000267028809px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.2,
    cy: 178.64,
    r: 3.8,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.6,181.2c-1,8,2.7,16,8.4,17.9s11.1-3.2,12.1-11.2-2.7-16-8.4-17.9S175.6,173.2,174.6,181.2Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 172.4,
    r: 2.1,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.6,
    cy: 182.89,
    r: 5.5,
    style: {
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "2.0929206130466724px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6dea6affb87da83a97c4902cf9197795.svg";
export { ForwardRef as ReactComponent };